export default __webpack_public_path__ + "static/media/checkmarx-long.0ba4372d.png";